import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var DwgShortcutSvg = function DwgShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1D2CF",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    fillRule: "evenodd",
    d: "M14.131 16.667 14.54 19h1.99l1.862-2.333z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    fillRule: "evenodd",
    d: "M19.001 16.667h-2.435V19h1.218z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    fillRule: "evenodd",
    d: "m12.237 5 4.33 7.883-6.398 1.336a9 9 0 0 0-1.643-2.417z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#381413",
    fillRule: "evenodd",
    d: "m15.78 11.467.969 5.2H19l-1.063-4.523z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    fillRule: "evenodd",
    d: "M10.902 16.667h6.273l-1.364-5.192-5.887 2.253c.485.899.822 1.889.978 2.939",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__f)",
    fillRule: "evenodd",
    d: "M10.903 16.675h3.237l-.625-4.308-3.58 1.384c.48.895.814 1.88.968 2.924",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    fillRule: "evenodd",
    d: "M9.837 13.572q.053.093.103.187l3.574-1.32L12.087 5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 14.936,
    x2: 15.469,
    y1: 18.309,
    y2: 17.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#AF2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#C32A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#CA2D28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 17.784,
    x2: 17.784,
    y1: 16.667,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A41E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A51F23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 11.696,
    x2: 11.696,
    y1: 12.659,
    y2: 6.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E1519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#84171A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#9D2021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#AF2524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#BA2826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#BE2927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB1F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 6.826,
    x2: 17.175,
    y1: 14.071,
    y2: 14.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#471514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__f",
    x1: 11.696,
    x2: 11.696,
    y1: 16.675,
    y2: 12.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#771315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#791416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#87181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C191C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__g",
    x1: 11.643,
    x2: 11.643,
    y1: 5,
    y2: 13.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE462F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#D8412D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#CA3228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C72F28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var DwgShortcut = function DwgShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: DwgShortcutSvg
  }));
};